const loaded = { currentId: null };

export function initClarity(projectId) {
  if (!projectId) return;
  if (loaded.currentId === projectId) return;
  loaded.currentId = projectId;

  const existing = document.getElementById('clarity-tag');
  if (existing) existing.remove();

  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  script.id = 'clarity-tag';
  document.head.appendChild(script);
}
